import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AuthSliceState {
    accessToken?: string;
    payerId?: string;
    segmentIds: string[];
    permissions: string[];
    restrictedAccess: boolean;
    analyticsAccess: boolean;
}

const initialState: AuthSliceState = {
    accessToken: undefined,
    payerId: undefined,
    segmentIds: [],
    permissions: [],
    restrictedAccess: false,
    analyticsAccess: false,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAccessToken(
            state,
            action: PayloadAction<{
                accessToken: string;
                payerId: string;
                segmentIds: string[];
                permissions: string[];
                restrictedAccess: boolean;
                analyticsAccess: boolean;
            }>,
        ) {
            const {
                accessToken,
                payerId,
                segmentIds,
                permissions,
                restrictedAccess,
                analyticsAccess,
            } = action.payload;
            return {
                ...state,
                accessToken,
                payerId,
                segmentIds,
                permissions,
                restrictedAccess,
                analyticsAccess,
            };
        },
    },
});

export const { setAccessToken } = authSlice.actions;
